const getters = {
    token: state => state.user.token,
    isShowDepositPopup: state => state.user.isShowDepositPopup,
    isShowWithdrawPopup: state => state.user.isShowWithdrawPopup,
    isShowBankSetPopup: state => state.user.isShowBankSetPopup,
    isShowWithdrawPwdSetPopup: state => state.user.isShowWithdrawPwdSetPopup,
    rememberInfo: state => state.user.rememberMe,
    userInfo: state => state.user.userInfo,
    loginType: state => state.user.loginType,
    isShowLoginPopup: state => state.user.isShowLoginPopup,
    matterNumber: state => state.user.matterNumber,
    noticeNumber: state => state.user.noticeNumber,
    sysConfig: state => state.system.sysConfig,
    Pixel: state => state.system.Pixel,
    TaId: state => state.system.TaId,
    ClickId: state => state.system.ClickId,
    language: state => state.system.language,
    invitCode: state => state.user.invitCode,
    invitCodeNum: state => state.user.invitCodeNum,
    isShowMyProfilePopup: state => state.user.isShowMyProfilePopup,
    isShowMyPopup: state => state.user.isShowMyPopup,
    isShowSettingPopup: state => state.user.isShowSettingPopup,
    isShowBetHistoryPopup: state => state.user.isShowBetHistoryPopup,
    isShowTransactionPopup: state => state.user.isShowTransactionPopup,
    isShowRedPacketPopup: state => state.user.isShowRedPacketPopup,
    isShowDownAppPopup: state => state.user.isShowDownAppPopup,
    isShowCheckInPopup: state => state.user.isShowCheckInPopup,
    isShowPendingPopup: state => state.user.isShowPendingPopup,
    isShowTurntablePopup: state => state.user.isShowTurntablePopup,
    isShowTurntable2Popup: state => state.user.isShowTurntable2Popup,
    isShowLossSupportPopup: state => state.user.isShowLossSupportPopup,
    isShowRebatePopup: state => state.user.isShowRebatePopup,
    isShowWinRankListPopup: state => state.user.isShowWinRankListPopup,
    isShowPinduodouPopup: state => state.user.isShowPinduodouPopup,
    isShowTreasureChestPopup: state => state.user.isShowTreasureChestPopup,
    isShowPartnerPopup: state => state.user.isShowPartnerPopup,
    bankItem: state => state.user.bankItem,
    withdrawPwdForm: state => state.user.withdrawPwdForm,
    telegramUserId: state => state.system.telegramUserId,
    isShowPlayGamePopup: state => state.system.isShowPlayGamePopup,
    themeSkin: state => state.system.themeSkin
}
export default getters
